var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sai-card"},[_c('div',{staticClass:"card-header"},[_vm._t("card-header")],2),_c('div',{staticClass:"card-body"},[_vm._t("card-body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }